<template>
  <div class="ace-editor-ba">
    <div
      :id="`ace-code-editor-${this.editorId}`"
      :style="`height: ${ height ? height : 400}px;`"
      class="form-control"
    >
      {{ content }}
    </div>
  </div>
</template>

<script>
import ace from'ace-builds'
import'ace-builds/webpack-resolver'//must be imported for use in the webpack environment
import'ace-builds/src-noconflict/theme-monokai'//theme set by default
import'ace-builds/src-noconflict/mode-javascript'//Language mode set by default
import'ace-builds/src-noconflict/ext-rtl'//Language mode set by default

export default {
  name: 'AceCodeEditor',
  props: ['editorId', 'content', 'lang', 'theme', 'config', 'height'],
  data() {
    return {
      editor: Object,
      beforeContent: '',
      value: ''
    };
  },
  watch: {
    content(value) {
      if (this.beforeContent !== value) {
        this.value = this.content;
      }
    },
    value(value){
      if (this.beforeContent !== value) {
        this.$emit('change-content', this.value, this.config);
      }
    }
  },
  mounted() {
    //this.value = this.content;
    const lang = this.lang || 'javascript';
    const theme = this.theme || 'tomorrow';

    this.editor = ace.edit('ace-code-editor-' + this.editorId);
    this.editor.setTheme(`ace/theme/${theme}`);
    this.editor.session.setMode(`ace/mode/${lang}`);

    let options = { autoScrollEditorIntoView: true };

    let rtl = {
      rtlText: true,
      rtl: true
    };

    this.editor.setOptions(
      this.$translate.getDir() ? { ...options, ...rtl } : options
    );

    if (this.$translate.getDir())
      this.editor.session.$bidiHandler.setRtlDirection(this.editor, true);

    if (this.content) this.editor.setValue(this.content, 1);

    this.editor.on('change', () => {
      this.beforeContent = this.editor.getValue();
      this.$emit('change-content', this.editor.getValue(), this.config);
    });
  }
};
</script>

<style lang="scss">
  html[dir='rtl'] {
    .ace-editor-ba{
      span, label{
        float: none !important;
        text-align: left !important
      }
    }
  }
  .ace-editor-ba, .ace-editor-ba * {
    font-family: monospace !important;
    font-size: 16px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/AceCodeEditor.vue